import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import { MdModeEditOutline, MdDelete } from "react-icons/md";
import { FaFemale, FaMale, FaLink } from "react-icons/fa";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../helpers";
import moment from "moment";
import { IoCopySharp } from "react-icons/io5";
import Tooltip from "../Tooltip";
import { MenuItem, Select } from "@mui/material";
import { Form, Formik } from "formik";
import { styled } from "@mui/material/styles";

const Tables = ({
  apiData,
  setSelectedData,
  setIsStaffAttendance,
  attendanceFlag,
  setIsEditStaff,
  setLinkStaff,
  setIsStaffSummary,
  setStaffPermission,
  setLocationModel,
  openLogs,
  setIsDeleteStaff,
  getInventoryListMutate,
  setIsDeactivateStaff,
}) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const edit = (item) => {
    setIsEditStaff(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const deletestaff = (item) => {
    setIsDeleteStaff(true);
    setSelectedData(item);
  };
  const ActionBtns = (item) => (
    <div className="flex items-center gap-3">
      {/* LINK / UNLINK BUTTON */}
      <Tooltip label="Manage Inventory">
        <button
          onClick={() => {
            setSelectedData(item);
            setLinkStaff(true);
          }}
          className="text-gray-400 hover:text-blue-600 transition bg-gray-50 rounded-full p-1.5"
        >
          <FaLink />
        </button>
      </Tooltip>

      <Tooltip label="Click to edit the staff">
        <button
          onClick={() => edit(item)}
          className="text-gray-400 hover:text-gray-700 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdModeEditOutline size={16} />
        </button>
      </Tooltip>
      <Tooltip label="Click to delete the staff">
        <button
          onClick={(e) => {
            e.stopPropagation();
            deletestaff(item);
          }}
          className="text-gray-400 hover:text-rose-600 transition bg-gray-50 rounded-full p-1.5"
        >
          <MdDelete size={16} />
        </button>
      </Tooltip>
    </div>
  );

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.name);

    return (
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center">
          {item.gender === 1 ? (
            <FaMale className="text-blue-500" />
          ) : (
            <FaFemale className="text-pink-500" />
          )}
        </div>
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <span className="font-medium text-gray-600 truncate max-w-[140px]">
              {truncateText(name, 25)}
            </span>
          </div>

          <div className="flex items-center gap-1 text-xs text-gray-400">
            #{item.mobile}
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.mobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy Number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </div>
    );
  };
  const getStatus = (status) => {
    if (status === 1) {
      return (
        <span className="text-xs text-green-600 bg-green-50 px-3 py-1 rounded-full">
          Active
        </span>
      );
    } else {
      return (
        <span className="text-xs text-red-600 bg-red-50 px-3 py-1 rounded-full">
          Inactive
        </span>
      );
    }
  };

  // const CustomSelect = styled(Select)({
  //   "& .MuiSelect-select": {
  //     padding: "6px 32px 6px 12px",
  //     display: "flex",
  //     alignItems: "center",
  //   },

  //   "& .MuiSelect-icon": {
  //     color: "#22c55e",
  //   },

  //   "& .MuiOutlinedInput-notchedOutline": {
  //     border: "none",
  //   },

  //   "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
  //     border: "none",
  //   },

  //   "&:hover .MuiOutlinedInput-notchedOutline": {
  //     border: "none",
  //   },
  // });

  // const getStatus = (item) => {
  //   return (
  //     <Formik
  //       initialValues={{
  //         status: item?.status,
  //       }}
  //       enableReinitialize
  //       onSubmit={() => {}}
  //     >
  //       {({ setFieldValue, values }) => (
  //         <Form>
  //           <CustomSelect
  //             value={values.status || ""}
  //             onChange={(e) => {
  //               const selectedStatus = e.target.value;

  //               setFieldValue("status", selectedStatus);

  //               setSelectedData({
  //                 ...item,
  //                 status: selectedStatus,
  //               });

  //               setIsDeactivateStaff(true);
  //             }}
  //             variant="outlined"
  //             size="small"
  //             className={`!rounded-lg !font-small !text-sm !h-8 min-w-[110px] ${
  //               values.status === 1
  //                 ? "bg-green-50 !text-green-600"
  //                 : "bg-red-50 !text-red-600"
  //             }`}
  //           >
  //             <MenuItem value={1}>Active</MenuItem>
  //             <MenuItem value={2}>Inactive</MenuItem>
  //           </CustomSelect>
  //         </Form>
  //       )}
  //     </Formik>
  //   );
  // };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        createdAt: item?.lastLogin
          ? getLastLogin(item?.lastLogin)
          : getLastLogin(item.createdAt),
        salary: item?.salary ? "₹" + item.salary : "N/A",
        action: ActionBtns(item),
        status: getStatus(item.status),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  const getLoginTimeColor = (lastLogin) => {
    if (!lastLogin) return "#9CA3AF"; // Grey - Never logged in

    const days = moment().diff(moment(lastLogin), "days");

    if (days <= 1) return "bg-green-50"; // Green
    if (days <= 3) return "bg-yellow-50"; // Yellow
    if (days <= 7) return "bg-orange-50"; // Orange

    return "bg-rose-50"; // Red
  };

  const getLastLogin = (lastLogin) => {
    const bg = getLoginTimeColor(lastLogin);

    return (
      <Tooltip label={`Last login: ${moment(lastLogin).fromNow()}`}>
        <span className={`${bg} px-3 py-1 rounded-md text-xs text-gray-700`}>
          {moment(lastLogin).format("DD MMM, hh:mm A")}
        </span>
      </Tooltip>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Salary",
          accessor: "salary",
        },
      ];
    }
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Salary",
        accessor: "salary",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Last Login",
        accessor: "createdAt",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(apiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Role:</strong> {data[rowIndex].Role}
                        </li>

                        <li className="flex gap-2">
                          <strong>Attendance Status:</strong>{" "}
                          {data[rowIndex].attendanceStatus}
                        </li>
                        <li className="flex gap-2">
                          <strong>Check In:</strong> {data[rowIndex].checkIn}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {/* {apiData?.length === 0 && <NotFoundModel />} */}
    </>
  );
};
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`
  border-b
  hover:bg-slate-50
  transition
`;
export default Tables;
